import _ from 'lodash';
import React, {Fragment, useState, useContext} from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Container} from 'react-bootstrap'
import socials from '../../data/SocialNetworks'
import Paragraph from "../../components/paragraph";
import { GlobalContext } from "../../handlers/GlobalContext";

const compare = (comperator) => (arr1, arr2) =>
    _.zip(arr1, arr2)
        .filter(comperator)
        .map(_.last);

const eq = _.spread(_.eq);
const intersection = compare(eq);
const difference = compare(_.negate(eq));


const BlogDetailsContent = ({title, meta, methods}) => {
    const navigate = useHistory();
    const [ openPanel, setOpenPanel] = useState(0);
    const pssFields = ["pssSolvents","pssAmount","pssConcentration","pssStability"]
    const pssFieldsTitles = ["Solvents", "Amount of solvents","Concentration of stock solution","Physicochemical stability of stock solution"]
    const psdFields = ["psdSolvents","psdAmount","psdFinalConcentration","psdInfusionRate","psdStability"]
    const psdFieldsTitles = ["Dilution solvents", "Amount of dilution solvents","Final concentration","Administration time/rate","Physicochemical stability of solution for administration"]

    const [ state, dispatch ] = useContext(GlobalContext);

    let productDetails = [
        [ 'product-details-pharmForm', 'pharmaceuticalFormName' ],
        [ 'product-details-characteristics', 'pharmaceuticalFormCharacteristics' ],
        [ 'product-details-manufacturer', 'manufacturer' ],
        [ 'product-details-strength', 'strength' ],
        [ 'product-details-storage', 'storage' ]
        ].map((item) => {
            return [item[0], meta[item[1]]];
        })


    let methodSubtitled = false;
    if(!!meta.country && meta.country.countryId == 7 && methods.length > 0){
        let countryArray = _.map(methods, 'countries');
        let initArray = _.map(countryArray[0], 'code');

        methodSubtitled = !_.every(_.map(countryArray, (cArray) => { return _.isEqual(initArray, _.map(cArray,'code')) }))
    }

    function switchTab(t){
        setOpenPanel(t);
    }

    const get_host = (url) => {
        return url.replace(/^((\w+:)?\/\/[^\/]+\/?).*$/,'$1');
    }
    const remove_url = (desc) => {
        return desc.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '');
    }

    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }

    return (
        <Fragment>
            <div className="blog-content">

                <h2 className="blog-title">{title}</h2>

                <ul className="blog-meta">
                    <li className="sub-ordinate">
                        <a href={""} onClick={(e) => { e.preventDefault(); }}> {/*{`${process.env.PUBLIC_URL + '/medicinal-products-by-drug/' + meta.drugId}`}*/}
                            <i className="fa fa-flask"/>{meta.drugName}
                        </a>
                    </li>
                </ul>

                <div className="blog-product">
                    <Container>
                        {productDetails.map( (item,idx) => (
                            <Row className="product-info-row" key={'detail_' + idx}>
                                <Col xl={3} className="product-info-label" >
                                    <span>{translate(item[0])}</span>
                                </Col>
                                <Col xl={9}>
                                    <Paragraph pContext={item[0]} pText={item[1]}/>
                                    {/*<p>{item[1]}</p>*/}
                                </Col>
                            </Row>
                        ))}
                    </Container>
                </div>

                <div className="blog-product-preparation-methods">
                    <Container className="product-method-info" key={'prep_method_detail_global'}>
                        <Row className="method-title-tabs" >

                                {methods.map( (item,idx) => (
                                    <Col key={'prep_method_tab_' + idx} xl={12/methods.length} className={( openPanel == idx ? 'active-tab' : '' ) } onClick={() => { switchTab(idx)} }>
                                        <span>{item.preparationMethod}</span>
                                        { (!!methodSubtitled && item.countries.length > 0) ?
                                            <div className={( openPanel == idx ? 'active-subtab' : 'subtab' ) }> (
                                                {
                                                    item.countries.map( (cntry, cntryIdx) => (
                                                        <small key={'prep_method_country_' + cntryIdx}>{cntry.longName + (cntryIdx < (item.countries.length - 1) ? ', ' : '') }</small>
                                                    ))
                                                })
                                            </div> :
                                            null }
                                    </Col>
                                    ))
                                }
                        </Row>
                    </Container>


                    {methods.map( (item,idx) => (
                        <Container className="product-method-info" key={'prep_method_detail_' + idx}>



                            <div className={'product-method-info-div' + ( openPanel == idx ? '-active' : '' ) }>



                                <Row className={"method-desc header method-use " + (!!item.readyToUse ? "ready-yes" : "ready-no")}>
                                    <Col xl={4}>
                                        <span> {translate("product-details-readyToUse","Ready to use")}</span>
                                    </Col>
                                    <Col xl={8}>
                                        <Paragraph pContext={'readyToUse'} pText={!!item.readyToUse ? translate('product-details-yes','Yes') : translate('product-details-no','No')}/>
                                    </Col>
                                </Row>

                                <div className="page-break"></div>
                                { _.filter(_.pick(item, pssFields), (x) => {
                                    return !!x; }).length > 0 ?
                                    <Row className="method-desc header">
                                        <Col xl={12}>
                                            <span>{translate("product-details-pssTitle","Preparation of stock solution (Reconstitution)")}</span>
                                        </Col>
                                    </Row>
                                    : null }
                                <div className="page-break"></div>
                                {
                                    pssFields.map( (pssField, pssIdx) => (
                                        <div className={"method-desc" + ( _.isNull(item[pssField]) ? "empty" : "" )} key={'pss_' + pssField}>
                                            <div className="page-break"></div>
                                            { _.isNull(item[pssField]) ? null :
                                                <Row>
                                                    <Col xl={4}>
                                                        <span>{ translate("product-details-" + pssField, pssFieldsTitles[pssIdx])}</span>
                                                    </Col>
                                                    <Col xl={8}>
                                                        <Paragraph pContext={pssField} pText={item[pssField]}/>
                                                    </Col>
                                                </Row>
                                            }
                                        </div>



                                    ))
                                }
                                <div className="page-break"></div>
                                {_.filter(_.pick(item, psdFields), (x) => {
                                    return !!x;
                                }).length > 0 ?
                                    <Row className="method-desc header">
                                        <Col xl={12}>
                                            <span>{translate("product-details-psdTitle","Preparation of solution for administration (Dilution)")}</span>
                                        </Col>
                                    </Row>
                                    : null
                                }
                                <div className="page-break"></div>
                                {
                                    psdFields.map( (psdField, psdIdx) => (
                                        <div className={"method-desc" + ( _.isNull(item[psdField]) ? "empty" : "" )} key={'psd_' + psdField}>
                                            <div className="page-break"></div>
                                            {_.isNull(item[psdField]) ? null :
                                                <Row>
                                                    <Col xl={4}>
                                                        <span>{ translate("product-details-" + psdField, psdFieldsTitles[psdIdx]) }</span>
                                                    </Col>
                                                    <Col xl={8}>
                                                        <Paragraph pContext={psdField} pText={item[psdField]}/>
                                                    </Col>
                                                </Row>
                                            }
                                        </div>
                                    ))
                                }
                                <div className="page-break"></div>
                                {_.isNull(item.incompatibilities) ? null :
                                    <Row className="method-desc header">
                                        <Col xl={4}>
                                            <span>{translate("product-details-incompatibilities","Incompatibilities")}</span>
                                        </Col>
                                        <Col xl={8}>
                                            <Paragraph pContext={'incopatibilities'} pText={item.incompatibilities}/>
                                        </Col>
                                    </Row>
                                }
                                <div className="page-break"></div>
                                {_.isNull(item.specialInstruction) ? null :
                                    <Row className="method-desc header">
                                        <Col xl={4}>
                                            <span>{translate("product-details-instructions","Special instructions and precautions")}</span>
                                        </Col>
                                        <Col xl={8}>
                                            <Paragraph pContext={'precautions'} pText={item.specialInstruction}/>
                                        </Col>
                                    </Row>
                                }
                                <div className="page-break"></div>
                                {_.isNull(item.comments) ? null :
                                    <Row className="method-desc header">
                                        <Col xl={4}>
                                            <span>{translate("product-details-comments","Comments")}</span>
                                        </Col>
                                        <Col xl={8}>
                                            <Paragraph pContext={'comments'} pText={item.comments}/>
                                        </Col>
                                    </Row>
                                }


                                {(item.preparationAttachment.length == 0) ? null :
                                    <Row className="method-desc header">
                                        <Col xl={4}>
                                            <span>{translate("product-details-references","References")}</span>
                                        </Col>
                                        <Col xl={8}>
                                            <div>
                                                {
                                                    item.preparationAttachment.map( (pAtach, pAtachIdx) => (
                                                        <div className={"reference"} key={"pAttach_" + idx + "_" + pAtachIdx}>
                                                            <a href={pAtach.url} target="_blank">
                                                                <i className="fa fa-external-link"/> {!!pAtach.description ? remove_url(pAtach.description) : get_host(pAtach.url)} </a>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </div>




                        </Container>
                    ))}
                </div>
            </div>



            <div className="blog-footer col-12 pl-0 pr-0 fix">
                <div className="row">

                    <div className="d-flex justify-content-start col-md-3 col-6 order-2 order-md-1">
                        <div className="post-nav old-post" onClick={() => navigate.goBack()}>
                            <i className="fa fa-long-arrow-left"/> {translate("product-button-back","BACK").toUpperCase()}
                        </div>
                    </div>

                </div>
            </div>
        </Fragment>
    );
};

export default BlogDetailsContent;